var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.routePath === '/detail')?_c('div',{style:(_vm.bgStyle),attrs:{"id":"app1"}},[_c('layout-header'),_c('router-view',{staticClass:"content"})],1):_c('div',{attrs:{"id":"app"}},[_c('router-view',{staticClass:"content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }